import type { CartData, ElevarProduct } from 'types'
import { mapCartProducts } from './cart-mapper'
import { buildCartUrls } from './cart-url-builder'
import { getShopUrl } from './get-shop-url'

export const buildSegmentPayload = (
  cart: CartData,
  baseProduct?: ElevarProduct
) => {
  const { cartUrl, checkoutUrl } = buildCartUrls(cart, getShopUrl())
  const cartProducts = mapCartProducts(cart.items)
  const product = baseProduct

  const basePayload = {
    cart_id: cart.token,
    cart_url: cartUrl,
    checkout_url: checkoutUrl,
    currency: 'USD',
    products: cartProducts,
    total_price: (cart.total_price / 100).toFixed(2),
    original_total_price: (cart.original_total_price / 100).toFixed(2),
    total_discount: (cart.total_discount / 100).toFixed(2),
    item_count: cart.item_count,
    total_weight: cart.total_weight,
    attributes: cart.attributes,
    discount_codes: cart.discount_codes || [],
  }

  if (product) {
    return {
      ...basePayload,
      ...(product.category && { category: product.category }),
      ...(product.brand && { brand: product.brand }),
      ...(product.url && { url: product.url }),
      ...(product.product_id && { product_id: product.product_id }),
      ...(product.id && { sku: product.id }),
      ...(product.name && { name: product.name }),
      ...(product.price && { price: Number.parseFloat(product.price) }),
      ...(product.variant && { variant: product.variant }),
      ...(product.quantity && {
        quantity: Number.parseInt(product.quantity, 10),
      }),
      ...(product.product_id && { shopify_product_id: product.product_id }),
      ...(product.variant_id && { shopify_variant_id: product.variant_id }),
      ...(product.price && {
        presentment_amount: Number.parseFloat(product.price).toFixed(2),
      }),
      ...(product.price && { presentment_currency: 'USD' }),
      ...(product.image && { image_url: product.image }),
    }
  }

  return basePayload
}
